import i18next from 'i18next';

/** Registers English strings for the program package. */
export default function initI18n(): void {
  i18next.addResourceBundle('en', 'program', {
    program: 'Program',
    programs: 'Programs',
    programPhase: 'Program phase',
    programLesson: 'Program lesson',
    programStep: 'Program step',
    programHabit: 'Program habit',
    programMetric: 'Program metric',
    programParameter: 'Program parameter',
    userProgram: 'User program',
    publishedRowRefusal: 'Program belongs to the shared library and cannot be changed',
    publishNeedsOutcomeMetric: 'Set an outcome metric before publishing',
    publishNeedsPhaseLesson: 'Add at least one phase with a lesson before publishing',
  });

  i18next.addResourceBundle('en', 'ai-tool', {
    listLibraryMetrics: 'List library metrics',
    listLibraryMetricsReasoning: 'Listing library metrics',
    listLibraryMetricsOutput: 'Listed library metrics',
    listLibraryMetricsError: 'Error listing library metrics',
    listLibraryMetricsNoop: 'No library metrics found',
    readProgramOutline: 'Read program outline',
    readProgramOutlineReasoning: 'Reading program outline',
    readProgramOutlineOutput: 'Read program outline',
    readProgramOutlineError: 'Error reading program outline',
    saveProgramDraft: 'Save program draft',
    saveProgramDraftReasoning: 'Saving program draft',
    saveProgramDraftOutput: 'Saved program draft',
    saveProgramDraftError: 'Error saving program draft',
    draftLessonPage: 'Draft lesson page',
    draftLessonPageReasoning: 'Drafting lesson page',
    draftLessonPageOutput: 'Drafted lesson page',
    draftLessonPageError: 'Error drafting lesson page',
    generateLessonQuestions: 'Generate lesson questions',
    generateLessonQuestionsReasoning: 'Generating lesson questions',
    generateLessonQuestionsOutput: 'Generated lesson questions',
    generateLessonQuestionsError: 'Error generating lesson questions',
    addProgramHabits: 'Add program habits',
    addProgramHabitsReasoning: 'Adding program habits',
    addProgramHabitsOutput: 'Added program habits',
    addProgramHabitsError: 'Error adding program habits',
    addProgramMetrics: 'Add program metrics',
    addProgramMetricsReasoning: 'Adding program metrics',
    addProgramMetricsOutput: 'Added program metrics',
    addProgramMetricsError: 'Error adding program metrics',
    findPrograms: 'Find programs',
    findProgramsReasoning: 'Finding programs',
    findProgramsOutput: 'Found {{toolCall.output.count}} programs',
    findProgramsError: 'Error finding programs',
    findProgramsNoop: 'No programs found',
    readProgram: 'Read program',
    readProgramReasoning: 'Reading program',
    readProgramOutput: 'Read program',
    readProgramError: 'Error reading program',
    findUserPrograms: 'Find your programs',
    findUserProgramsReasoning: 'Finding your programs',
    findUserProgramsOutput: 'Found {{toolCall.output.count}} enrollments',
    findUserProgramsError: 'Error finding your programs',
    findUserProgramsNoop: 'No enrollments found',
    readUserProgram: 'Read your program',
    readUserProgramReasoning: 'Reading your program',
    readUserProgramOutput: 'Read your program',
    readUserProgramError: 'Error reading your program',
    tryProgram: 'Try a program',
    tryProgramReasoning: 'Offering a program',
    tryProgramOutput: 'Chose {{toolCall.output.selected}}',
    tryProgramError: 'Error offering a program',
    startProgram: 'Start program',
    startProgramReasoning: 'Starting program',
    startProgramOutput: 'Start card ready',
    startProgramError: 'Error starting program',
    startProgramPhase: 'Start program phase',
    startProgramPhaseReasoning: 'Starting program phase',
    startProgramPhaseOutput: 'Started program phase',
    startProgramPhaseError: 'Error starting program phase',
    nextProgramStep: 'Next program step',
    nextProgramStepReasoning: 'Offering the next step',
    nextProgramStepOutput: 'Chose {{toolCall.output.selected}}',
    nextProgramStepError: 'Error offering the next step',
    selectInProgram: 'Open in program',
    selectInProgramReasoning: 'Opening the runner',
    selectInProgramOutput: 'Opened the runner',
    selectInProgramError: 'Error opening the runner',
    completeProgramStep: 'Complete program step',
    completeProgramStepReasoning: 'Completing program step',
    completeProgramStepOutput: 'Completed program step',
    completeProgramStepError: 'Error completing program step',
    updateProgramParameters: 'Update program answers',
    updateProgramParametersReasoning: 'Updating program answers',
    updateProgramParametersOutput: 'Updated program answers',
    updateProgramParametersError: 'Error updating program answers',
    pauseProgram: 'Pause program',
    pauseProgramReasoning: 'Pausing program',
    pauseProgramOutput: 'Paused program',
    pauseProgramError: 'Error pausing program',
    resumeProgram: 'Resume program',
    resumeProgramReasoning: 'Resuming program',
    resumeProgramOutput: 'Resumed program',
    resumeProgramError: 'Error resuming program',
    abandonProgram: 'Abandon program',
    abandonProgramReasoning: 'Abandoning program',
    abandonProgramOutput: 'Abandoned program',
    abandonProgramError: 'Error abandoning program',
  });
}
